module.exports = __webpack_public_path__ + "static/img/bmcj.f6fa8b53.png";